export default __webpack_public_path__ + "files/83fe98186b9091a8ab563ad84c4e956f.svg";